import { render, staticRenderFns } from "./CarOwners.vue?vue&type=template&id=25b40106&scoped=true"
import script from "./CarOwners.vue?vue&type=script&lang=js"
export * from "./CarOwners.vue?vue&type=script&lang=js"
import style0 from "./CarOwners.vue?vue&type=style&index=0&id=25b40106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b40106",
  null
  
)

export default component.exports